export default __webpack_public_path__ + "static/7_15-cb74afe95ac218df55fb74fa8f72d119.png";